import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledAnswerFeedback = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: bold;
  color: ${Colors.red};
  //font-family: 'hvd-comic';
  .feedback {
    margin-top: 2.5%;
  }
  .right-answer {
    margin-top: 0.5%;
    color: ${Colors.green};
    font-weight: bolder;
    font-size: 120%;
  }
`;
